import React, { useState } from 'react'
import Plus from '../icons/Plus'
import Modal from './Modal'
import AddAvailabilityModal from './AddAvailabilityModal'

type Props = {}

const AddButton = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer">
        <div className="text-white w-5 h-5">
          <Plus />
        </div>
        <div className="text-14 font-semibold text-white">Add availability</div>
      </div>
      <Modal isOpen={isOpen} toggleModal={() => setIsOpen(!isOpen)}>
        <AddAvailabilityModal toggleModal={() => setIsOpen(!isOpen)} />
      </Modal>
    </>
  )
}

export default AddButton
